<template>
  <div class="container">
    <div class="form-group">
      <div class="row">
        <div class="col-xs-4">
          <label for="school">校部</label>
        </div>
        <div class="col-xs-8">
          <select v-model="query.school" class="form-control">
            <option disabled>請選擇校部</option>
            <option v-for="(option, index) in allSchools" :key="index" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
      </div>
    </div>

    <hr>

    <div class="form-group">
      <div class="row">
        <div class="col-xs-4">
          <label for="school">班級</label>
        </div>
        <div class="col-xs-8">
          <select v-model="query.classroom" class="form-control">
            <option disabled>請選擇班級</option>
            <option v-for="(option, index) in displayClasses" :key="index" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
      </div>
    </div>

    <hr>

    <div class="form-group">
      <div class="row">
        <div class="col-xs-4">
          <label for="school">學號</label>
        </div>
        <div class="col-xs-8">
          <input type="number" pattern="\d*" class="form-control" v-model="query.number">
          <span class="help-block">班內學號</span>
        </div>
      </div>
    </div>

    <hr>

    <div class="form-group">
      <div class="row">
        <div class="col-xs-4">
          <label for="school">教青局學生證</label>
        </div>
        <div class="col-xs-8">
          <input type="number" pattern="\d*" class="form-control" v-model="query.dsej">
          <span class="help-block">
            教青局學生證中間4 位數字：123<span class="text-danger"><b>4567</b></span>-8<br/>
            或班主任提供的4 位數登入號碼
          </span>
        </div>
      </div>
    </div>

    <div class="alert alert-danger" role="alert" v-if="error_message">
      {{ error_message }}
    </div>

    <div class="form-group">
        <div class="row">
          <div class="col-xs-8 col-xs-offset-4">
            <button class="btn btn-primary" @click="loginAttemp">登入</button>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import p from 'es6-promise';
  import allClasses from '../clazz.json';

  p.polyfill();

  export default {
    name: 'LoginForm',
    data() {
      return {
        allSchools: [
          { label: '六校中文部', value: 'chi6' },
          { label: '六校英文部', value: 'eng6' },
        ],
        query: {
          school: '',
          classroom: '',
          number: '',
          dsej: '',
        },
        allClasses,
        info: null,
        error_message: null,
      };
    },
    computed: {
      displayClasses() {
        return this.allClasses[this.query.school];
      },
    },
    methods: {
      getRest() {
        axios
          .get('https://cdsj-sports-day.herokuapp.com/login', {
            params: this.query,
          })
          .then((res) => {
            if (res.data.length === 1) {
              this.$emit('login', res.data[0]);
            } else {
              this.error_message = '登入資訊不正確';
            }
          });
      },
      loginAttemp() {
        this.getRest();
      },
    },
  };
</script>

<style scoped>
  .help-block {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginForm.vue